import navbarLogo from '@/assets/themes/default/navbar-logo.svg';
import fullLogo from '@/assets/themes/default/full-logo.svg';
import chatAvatar from '@/assets/themes/default/chat-avatar.svg';
import favicon from '@/assets/themes/default/favicon.ico';
import { getMarqueeLogos } from '../marqueeLogos';
import type { ThemeDefinition } from '../types';

export const defaultTheme: ThemeDefinition = {
  id: 'default',
  name: 'Strive',
  pageTitle: 'Strivelabs Platform - Workflow intelligence for a smarter workforce',
  assets: {
    navbarLogo,
    fullLogo,
    chatAvatar,
    clerkLogoUrl: 'https://assets.apps.strivelabs.co/public-assets/Color+Filled+Black.svg',
    favicon,
  },
  onboarding: {
    marqueeHeadline: 'Move faster with Strive.',
    marqueeBody: [
      'Strive brings strategy, execution, and measurement into one connected system — helping your team move from ideas to action faster across SEO, paid, content, and AI search.',
      'One platform to ideate, execute, and measure. Let’s get started.',
    ],
    marqueeTrustCaption: 'Trusted by marketing teams at fast-growing companies',
    marqueeLogos: getMarqueeLogos('strivelabs'),
  },
};
